<template>
  <div style="height:100%;">
    <template v-if="$store.state.dingding === 'dingtalk' && isSpecialData.projectStr" />
    <router-view v-else />
  </div>
</template>

<script>
import { getDingding } from '@/services/index'
import { mapActions, mapMutations } from 'vuex'
export default {
  data () {
    return {
      isReady: false,
      isSpecialData: {}
    }
  },
  computed: {
  },
  async created () {
    if (this.$store.state.dingding === 'dingtalk') {
      this.getData()
    }
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapMutations(['setRoleDefault']),
    async getData () {
      const chain = await getDingding()
      chain.onSuccess(async (raw) => {
        this.isSpecialData = raw
        this.isReady = true
        if (this.isSpecialData.projectStr) {
          await this.specialTo(raw)
        }
      })
        .fetch()
    },
    async specialTo (datas) {
      this.$store.commit('setPid', datas.projectStr)
      let to = ''
      const pid = datas.projectStr // this.$store.state.pid
      to = {
        name: 'ProjectIndex',
        params: {
          pid
        },
        query: {
          cid: datas.cid * 1
        }
      }
      this.$router.push(to)
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/css/mobile.scss';
</style>
